module.exports = __webpack_public_path__ + "assets/ca5d7aa2b674fa925b8d6c0cc41e75e0.png";